import { FC, useContext, useEffect, useState } from "react";

import {
  Typography,
  Box,
  Grid,
  useMediaQuery,
  Table,
  TableRow,
  TableCell,
  TableBody,
  Container,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core";
import MyPortfolioMobileList from "./MyPortfolioMobileList";
import MyPortfolioDesktopList from "./MyPortfolioDesktopList";
import useStyles from "../Styles/ShowProjectStyles";
import AdminHeader from "../SubComponents/AdminHeader";
import Footer from "../SubComponents/Footer";
import ProjectPoolHeading from "../Projects/ProjectPoolHeading";
import getUserPortfolio from "../../utils/queries/Portfolio/getUserPortfolio";
import Pagination from "../../helpers/Pagination";
import NoDataFound from "../../helpers/NoDataFound";
import AlertContext from "../../store/Alert/AlertContext";
import graphQLClient from "../../utils/authHeader";
import BackButton from "../../helpers/BackButton";
import useModal from "../../hooks/useModal";
import ClaimActionResultModal from "../Modals/claim-modals/ClaimActionResultModal";
import EmptyInvestments from "./EmptyInvestments";
import { UserPortfolioSchema } from "../../constants/user-investment";

const Portfolio: FC = () => {
  const theme = useTheme();
  const isActive = useMediaQuery(theme.breakpoints.down("md"));
  const [dataa, setDataa] = useState<any[]>([]);
  const [noData, setNoData] = useState(false);
  const [maxLimit, toggleMaxLimit] = useState(false);

  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(3);

  const [data, setData] = useState<any>([]);
  const [error, setError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(true);

  const {
    close: closeClaimActionModal,
    open: openClaimActionModal,
    isOpen: isClaimActionModalOpen,
    payload: claimActionModalPayload,
  } = useModal();

  const { setAlert } = useContext<any>(AlertContext);

  useEffect(() => {
    graphQLClient
      .request(getUserPortfolio, {
        limit,
        offset,
      })
      .then((response) => {
        if (response.getUserPortfolio.length <= 0 && dataa.length <= 0) {
          setNoData(true);
        } else setData(response);
      })
      .catch((error) => {
        setError(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [offset]);

  useEffect(() => {
    if (data && data.getUserPortfolio) {
      setDataa((prev: any[]) => [...prev, ...data.getUserPortfolio]);
      if (data.getUserPortfolio.length < limit) {
        toggleMaxLimit(true);
      }
    }
    if (error) {
      setAlert(
        "Error fetching your portfolio, please try again later.",
        "error"
      );
    }
  }, [data, error]);

  function handleClickPagination() {
    setOffset((prevValue) => prevValue + limit);
  }

  const getTotalTokens = ({
    contribution,
    tokensPerOneCurrency,
  }: {
    contribution: number;
    tokensPerOneCurrency: number;
  }) => {
    return tokensPerOneCurrency * contribution;
  };

  const getReceivedTokens = ({
    contribution,
    receivedTokensPercentage,
    tokensPerOneCurrency,
  }: {
    contribution: number;
    receivedTokensPercentage: number;
    tokensPerOneCurrency: number;
  }) => {
    const receivedTokens =
      getTotalTokens({ contribution, tokensPerOneCurrency }) *
      receivedTokensPercentage;
    return receivedTokens;
  };

  const classes = useStyles();
  return (
    <>
      <AdminHeader />
      <Box
        className={classes.projectspages}
        mt={isActive ? 3 : 5}
        mb={5}
        component="section"
      >
        <Container fixed>
          <Grid container>
            <BackButton goBack />
            <Grid item md={12} sm={12} xs={12}>
              <ProjectPoolHeading title1="My" title2="Portfolio" />
            </Grid>
            <Grid item md={12} sm={12} xs={12}>
              {isActive ? (
                <>
                  {error ? (
                    <Box textAlign="center">
                      <Typography variant="h3">Can't Fetch Data</Typography>
                    </Box>
                  ) : (
                    <>
                      <Grid container spacing={3}>
                        <>
                          {dataa.map((data: any, index: any) => {
                            const {
                              id,
                              poolId,
                              projectName,
                              status,
                              contribution,
                              poolPrice,
                              receivedTokensPercentage,
                              tokensPerOneCurrency,
                              contributionAddress,
                              percentageFromPoolPrice,
                              details,
                              projectImageUrl,
                              distributionScAddress,
                              poolRefundPolicy,
                              investmentRefundPayload,
                              poolTgeDate,
                              distributionStatusDescription,
                              totalTokenClaimable,
                              totalTokenClaimed,
                              isExternalProject,
                              code,
                            } = data as UserPortfolioSchema;
                            return (
                              <MyPortfolioMobileList
                                key={index}
                                id={id.toString()}
                                poolId={poolId}
                                title={projectName}
                                imgSrc={projectImageUrl}
                                status={status}
                                contr={contribution}
                                tokenReceived={
                                  getReceivedTokens({
                                    contribution,
                                    receivedTokensPercentage,
                                    tokensPerOneCurrency,
                                  }).toFixed(2) +
                                  " / " +
                                  getTotalTokens({
                                    contribution,
                                    tokensPerOneCurrency,
                                  }).toFixed(2)
                                }
                                address={contributionAddress}
                                link={details}
                                price={poolPrice}
                                percent={percentageFromPoolPrice}
                                btn="primary"
                                distributionScAddress={distributionScAddress}
                                claimModalActionProps={{ openClaimActionModal }}
                                poolRefundPolicy={poolRefundPolicy}
                                investmentRefundPayload={
                                  investmentRefundPayload
                                }
                                poolTgeDate={poolTgeDate}
                                distributionStatusDescription={distributionStatusDescription}
                                totalTokenClaimable={totalTokenClaimable}
                                totalTokenClaimed={totalTokenClaimed}
                                isExternalProject={isExternalProject}
                                code={code}
                              />
                            );
                          })}
                        </>
                      </Grid>
                      {noData && !maxLimit && (
                        <Box textAlign="center">
                          <EmptyInvestments />
                        </Box>
                      )}
                    </>
                  )}
                </>
              ) : (
                <>
                  <Table className={classes.portfoliohead}>
                    <TableBody>
                      <TableRow>
                        {/** Flex Box main */}
                        <TableCell className="" align="left">
                          <Typography
                            component="span"
                            variant="subtitle1"
                            className="fw-bold"
                          >
                            Project
                          </Typography>
                        </TableCell>
                        <TableCell className="" align="left">
                          <Typography
                            component="span"
                            variant="subtitle1"
                            className="fw-bold"
                          >
                            Status
                          </Typography>
                        </TableCell>
                        <TableCell className="" align="left">
                          <Typography
                            component="span"
                            variant="subtitle1"
                            className="fw-bold"
                          >
                            Contribution
                          </Typography>
                        </TableCell>
                        <TableCell className="" align="left">
                          <Typography
                            component="span"
                            variant="subtitle1"
                            className="fw-bold"
                          >
                            Wallet
                          </Typography>
                        </TableCell>

                        <TableCell className="" align="left">
                          <Typography
                            component="span"
                            variant="subtitle1"
                            className="fw-bold"
                          >
                            Price ($)
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography
                            component="span"
                            variant="subtitle1"
                            className="fw-bold"
                          >
                            Tokens Received
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography
                            component="span"
                            variant="subtitle1"
                            className="fw-bold"
                          >
                            % Gain
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography
                            component="span"
                            variant="subtitle1"
                            className="fw-bold"
                          >
                            Refund
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Typography
                            component="span"
                            variant="subtitle1"
                            className="fw-bold"
                          >
                            Claim / Refund
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                  <Table className={classes.firsttable}>
                    <TableBody>
                      {error ? (
                        <Box textAlign="center" mt={5}>
                          <Typography variant="h3">Can't Fetch Data</Typography>
                        </Box>
                      ) : (
                        <TableRow>
                          <TableCell
                            style={{
                              paddingLeft: "0",
                              paddingRight: "0",
                              paddingBottom: "0",
                            }}
                          >
                            <>
                              {dataa.map((data: any, index: any) => {
                                const {
                                  id,
                                  poolId,
                                  projectName,
                                  status,
                                  contribution,
                                  poolPrice,
                                  receivedTokensPercentage,
                                  tokensPerOneCurrency,
                                  contributionAddress,
                                  percentageFromPoolPrice,
                                  details,
                                  projectImageUrl,
                                  distributionScAddress,
                                  poolRefundPolicy,
                                  investmentRefundPayload,
                                  poolTgeDate,
                                  distributionStatusDescription,
                                  totalTokenClaimable,
                                  totalTokenClaimed,
                                  isExternalProject,
                                  code,
                                } = data as UserPortfolioSchema;
                                return (
                                  <MyPortfolioDesktopList
                                    key={index}
                                    id={id.toString()}
                                    poolId={poolId}
                                    title={projectName}
                                    imgSrc={projectImageUrl}
                                    status={status}
                                    contr={contribution}
                                    tokenReceived={
                                      getReceivedTokens({
                                        contribution,
                                        receivedTokensPercentage,
                                        tokensPerOneCurrency,
                                      }).toFixed(2) +
                                      " / " +
                                      getTotalTokens({
                                        contribution,
                                        tokensPerOneCurrency,
                                      }).toFixed(2)
                                    }
                                    address={contributionAddress}
                                    link={details}
                                    price={poolPrice}
                                    percent={percentageFromPoolPrice}
                                    btn="primary"
                                    distributionScAddress={
                                      distributionScAddress
                                    }
                                    claimModalActionProps={{
                                      openClaimActionModal,
                                    }}
                                    poolRefundPolicy={poolRefundPolicy}
                                    investmentRefundPayload={
                                      investmentRefundPayload
                                    }
                                    poolTgeDate={poolTgeDate}
                                    distributionStatusDescription={distributionStatusDescription}
                                    totalTokenClaimable={totalTokenClaimable}
                                    totalTokenClaimed={totalTokenClaimed}
                                    isExternalProject={isExternalProject}
                                    code={code}
                                  />
                                );
                              })}
                            </>
                            {noData && !maxLimit && <EmptyInvestments />}
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </>
              )}
            </Grid>
          </Grid>
          {!noData && !maxLimit && !error && (
            <Pagination
              handleClick={handleClickPagination}
              isLoading={isLoading}
            />
          )}
        </Container>
      </Box>
      <Footer />

      <ClaimActionResultModal
        onClose={closeClaimActionModal}
        isOpen={isClaimActionModalOpen}
        payload={claimActionModalPayload}
      />
    </>
  );
};

export default Portfolio;
